<div class="schedule-view-container">
    <mat-tab-group (selectedIndexChange)="onTabChange($event)" [selectedIndex]="selectedTabId" matTabGroupGesture
        [swipeLimitWidth]="80" [connectEdges]="true">
        <mat-tab>
            <ng-template mat-tab-label>
                Calendar
            </ng-template>
            <app-schedule-calendar #calendar></app-schedule-calendar>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Appointment List
            </ng-template>
            <app-schedule-list #list></app-schedule-list>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Tasks
            </ng-template>
            <app-task-calendar #tasks></app-task-calendar>
        </mat-tab>
    </mat-tab-group>
</div>